import { FC, useCallback } from 'react'
import { useTheme } from 'styled-components'

import { isBrowser } from '@syconium/weeping-figs'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { useUser } from '../../../app/_providers/UserProvider.client'
import { headerHeightPixels } from '../../../brunswick/constants'
import { NavContainer } from '../../../brunswick/containers/NavContainer'
import {
  solidModalBodyOpenClassName,
  solidModalPortalClassName,
} from '../../../brunswick/styles/constants'
import { NavSection } from '../../../types/graphql/site-fixtures'
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../modals/NextModal'
import { renderNavSection } from '../renderNavSection'

import {
  Body,
  CloseButton,
  CloseButtonIcon,
  TopLine,
  modalContentStyles,
  modalOverlayStyles,
} from './styles'

export const AccountNavTabModal: FC<{
  isOpen: boolean
  onClose: () => void
  section: NavSection
}> = ({ isOpen, onClose, section }) => {
  const {
    magnolia: {
      account: { navigation: strings },
    },
  } = useTranslation()
  const { user } = useUser()
  const { color } = useTheme()
  const { promoBarHeightMobilePixels } = NavContainer.useContainer()

  const getAdditionalOffset = useCallback(() => {
    const scrollTop = isBrowser
      ? // TODO: Fix this auto-generated suppression.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        document?.documentElement?.scrollTop || document?.body?.scrollTop
      : 0

    return promoBarHeightMobilePixels - Math.min(scrollTop, promoBarHeightMobilePixels)
  }, [promoBarHeightMobilePixels])

  return (
    <NextModal
      bodyOpenClassName={solidModalBodyOpenClassName}
      isOpen={isOpen}
      onRequestClose={onClose}
      closeTimeoutMS={0}
      portalClassName={solidModalPortalClassName}
      style={{
        content: modalContentStyles,
        overlay: {
          ...modalOverlayStyles,
          top: headerHeightPixels + getAdditionalOffset(),
        },
      }}
    >
      <Body>
        {user && (
          <TopLine>
            <span>
              {strings.menu.hi}
              {user.profile.firstName}
            </span>
          </TopLine>
        )}

        <CloseButton onClick={onClose} value='close'>
          <CloseButtonIcon stroke={color.deprecated.obsidian} />
        </CloseButton>

        {renderNavSection(section)}
      </Body>
    </NextModal>
  )
}
